import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command'
import { useNodes, useServices, useStacks } from '@/lib/cluster'

export function CommandPalette() {
  const [open, setOpen] = useState(false)
  const nav = useNavigate()
  const { data: nodes } = useNodes()
  const { data: services } = useServices()
  const { data: stacks } = useStacks()

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setOpen((v) => !v)
      }
      if (e.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  function go(path: string) {
    setOpen(false)
    nav(path)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="p-0">
        <Command>
          <CommandInput placeholder="Jump to… (Cmd+K)" />
          <CommandList>
            <CommandEmpty>No results.</CommandEmpty>
            <CommandGroup heading="Pages">
              {[
                ['/dashboard', 'Dashboard'],
                ['/alerts', 'Alerts'],
                ['/errors', 'Errors'],
                ['/backups', 'Backups'],
                ['/nodes', 'Nodes'],
                ['/stacks', 'Stacks'],
                ['/services', 'Services'],
                ['/settings/notifications', 'Settings — Notifications'],
                ['/settings/maintenance', 'Settings — Maintenance'],
                ['/settings/rules', 'Settings — Alert rules'],
                ['/audit', 'Audit log'],
              ].map(([to, label]) => (
                <CommandItem key={to} onSelect={() => go(to)}>
                  {label}
                </CommandItem>
              ))}
            </CommandGroup>
            {nodes && nodes.length > 0 && (
              <CommandGroup heading="Nodes">
                {nodes.map((n) => (
                  <CommandItem key={n.id} onSelect={() => go(`/nodes/${n.id}`)}>
                    {n.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {stacks && stacks.length > 0 && (
              <CommandGroup heading="Stacks">
                {stacks.map((s) => (
                  <CommandItem
                    key={s.name}
                    onSelect={() => go(`/stacks/${encodeURIComponent(s.name)}`)}
                  >
                    {s.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
            {services && services.length > 0 && (
              <CommandGroup heading="Services">
                {services.slice(0, 30).map((s) => (
                  <CommandItem key={s.id} onSelect={() => go(`/services/${s.id}`)}>
                    {s.name}
                  </CommandItem>
                ))}
              </CommandGroup>
            )}
          </CommandList>
        </Command>
      </DialogContent>
    </Dialog>
  )
}
